import { render, staticRenderFns } from "./brandTypeManage.vue?vue&type=template&id=54881f8d&scoped=true&"
import script from "./brandTypeManage.vue?vue&type=script&lang=js&"
export * from "./brandTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./brandTypeManage.vue?vue&type=style&index=0&id=54881f8d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54881f8d",
  null
  
)

export default component.exports